"use strict";

var _regeneratorRuntime = require("/opt/build/repo/node_modules/@babel/runtime/regenerator");

function _interopDefault(e) {
  return e && "object" == typeof e && "default" in e ? e.default : e;
}

var React = require("react"),
    React__default = _interopDefault(React),
    PropTypes = _interopDefault(require("prop-types"));

require("jquery/dist/jquery.min.js"), require("bootstrap/dist/css/bootstrap.min.css"), require("bootstrap/dist/js/bootstrap.min.js"), require("material-design-icons/iconfont/material-icons.css");

var pdfjs = _interopDefault(require("pdfjs-dist")),
    pdfjsWorker = _interopDefault(require("pdfjs-dist/build/pdf.worker.entry"));

function _typeof(e) {
  return (_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (e) {
    return typeof e;
  } : function (e) {
    return e && "function" == typeof Symbol && e.constructor === Symbol && e !== Symbol.prototype ? "symbol" : typeof e;
  })(e);
}

function _classCallCheck(e, t) {
  if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
}

function _defineProperties(e, t) {
  for (var a = 0; a < t.length; a++) {
    var n = t[a];
    n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(e, n.key, n);
  }
}

function _createClass(e, t, a) {
  return t && _defineProperties(e.prototype, t), a && _defineProperties(e, a), e;
}

function _inherits(e, t) {
  if ("function" != typeof t && null !== t) throw new TypeError("Super expression must either be null or a function");
  e.prototype = Object.create(t && t.prototype, {
    constructor: {
      value: e,
      writable: !0,
      configurable: !0
    }
  }), t && _setPrototypeOf(e, t);
}

function _getPrototypeOf(e) {
  return (_getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function (e) {
    return e.__proto__ || Object.getPrototypeOf(e);
  })(e);
}

function _setPrototypeOf(e, t) {
  return (_setPrototypeOf = Object.setPrototypeOf || function (e, t) {
    return e.__proto__ = t, e;
  })(e, t);
}

function _assertThisInitialized(e) {
  if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  return e;
}

function _possibleConstructorReturn(e, t) {
  return !t || "object" != typeof t && "function" != typeof t ? _assertThisInitialized(e) : t;
}

function _slicedToArray(e, t) {
  return _arrayWithHoles(e) || _iterableToArrayLimit(e, t) || _nonIterableRest();
}

function _arrayWithHoles(e) {
  if (Array.isArray(e)) return e;
}

function _iterableToArrayLimit(e, t) {
  if (Symbol.iterator in Object(e) || "[object Arguments]" === Object.prototype.toString.call(e)) {
    var a = [],
        n = !0,
        o = !1,
        r = void 0;

    try {
      for (var s, i = e[Symbol.iterator](); !(n = (s = i.next()).done) && (a.push(s.value), !t || a.length !== t); n = !0) {
        ;
      }
    } catch (e) {
      o = !0, r = e;
    } finally {
      try {
        n || null == i.return || i.return();
      } finally {
        if (o) throw r;
      }
    }

    return a;
  }
}

function _nonIterableRest() {
  throw new TypeError("Invalid attempt to destructure non-iterable instance");
}

var Alert = function () {
  function e() {
    return _classCallCheck(this, e), _possibleConstructorReturn(this, _getPrototypeOf(e).apply(this, arguments));
  }

  return _inherits(e, React.Component), _createClass(e, [{
    key: "render",
    value: function value() {
      return React__default.createElement("div", {
        className: "row alert text-danger h-auto h6 m-0"
      }, React__default.createElement("div", {
        className: "col-sm-2 text-right px-2"
      }, React__default.createElement("i", {
        className: "material-icons"
      }, "error_outline")), React__default.createElement("div", {
        className: "col-sm-10 text-left px-0"
      }, React__default.createElement("small", null, this.props.message)));
    }
  }]), e;
}();

Alert.propTypes = {
  message: PropTypes.string.isRequired
}, pdfjs.GlobalWorkerOptions.workerSrc = pdfjsWorker;

var RenderPdf = function () {
  function a(e) {
    var t;
    return _classCallCheck(this, a), (t = _possibleConstructorReturn(this, _getPrototypeOf(a).call(this, e))).canvasRef = React.createRef(null), t.pdf = null, t.state = {
      error: !1,
      errorMessage: "",
      src: e.src
    }, t.fetchPdf = t.fetchPdf.bind(_assertThisInitialized(t)), t;
  }

  return _inherits(a, React.Component), _createClass(a, [{
    key: "fetchPdf",
    value: function value() {
      var t, a, n, o, r;
      return _regeneratorRuntime.async(function (e) {
        for (;;) {
          switch (e.prev = e.next) {
            case 0:
              return e.prev = 0, e.next = 3, _regeneratorRuntime.awrap(pdfjs.getDocument(this.state.src).promise);

            case 3:
              return this.pdf = e.sent, this.props.pageCount(this.pdf.numPages), e.prev = 5, e.next = 8, _regeneratorRuntime.awrap(this.pdf.getPage(this.props.page));

            case 8:
              return t = e.sent, a = t.getViewport({
                scale: this.props.scale,
                rotation: this.props.rotation
              }), (n = this.canvasRef.current).height = a.height, n.width = a.width, o = {
                canvasContext: n.getContext("2d"),
                viewport: a
              }, r = t.render(o), e.prev = 15, e.next = 18, _regeneratorRuntime.awrap(r.promise);

            case 18:
              e.next = 24;
              break;

            case 20:
              e.prev = 20, e.t0 = e.catch(15), console.log("Error occured while rendering !\n", e.t0), this.setState({
                error: !0,
                errorMessage: "Error occured while rendering !"
              });

            case 24:
              e.next = 30;
              break;

            case 26:
              e.prev = 26, e.t1 = e.catch(5), console.log("Error while reading the pages !\n", e.t1), this.setState({
                error: !0,
                errorMessage: "Error while reading the pages !"
              });

            case 30:
              e.next = 36;
              break;

            case 32:
              e.prev = 32, e.t2 = e.catch(0), console.log("Error while opening the document !\n", e.t2), this.setState({
                error: !0,
                errorMessage: "Error while opening the document !"
              });

            case 36:
            case "end":
              return e.stop();
          }
        }
      }, null, this, [[0, 32], [5, 26], [15, 20]]);
    }
  }, {
    key: "render",
    value: function value() {
      return this.state.error ? (this.props.pageCount(-1), React__default.createElement(Alert, {
        message: this.state.errorMessage
      })) : (this.fetchPdf(), React__default.createElement("canvas", {
        ref: this.canvasRef,
        width: window.innerWidth,
        height: window.innerHeight
      }));
    }
  }]), a;
}();

RenderPdf.propTypes = {
  src: PropTypes.string.isRequired,
  page: PropTypes.number,
  scale: PropTypes.number,
  rotation: PropTypes.number,
  pageCount: PropTypes.func
}, RenderPdf.defaultProps = {
  page: 1,
  scale: 1,
  rotation: 0,
  pageCount: function pageCount() {}
};

var NextPageButton = function NextPageButton(e) {
  var t = e.css,
      a = e.page,
      n = e.pages,
      o = e.handleNextClick,
      r = "".concat(t || "btn btn-sm btn-link text-white pl-2").concat(a === n ? " disabled" : ""),
      s = _slicedToArray(React.useState(!1), 2),
      i = s[0],
      l = s[1];

  return React__default.createElement("button", {
    className: r,
    onClick: function onClick() {
      l(!0), o(), setTimeout(function () {
        l(!1);
      }, 500);
    },
    disabled: i
  }, React__default.createElement("i", {
    className: "material-icons"
  }, "keyboard_arrow_right"));
};

NextPageButton.propTypes = {
  css: PropTypes.string,
  page: PropTypes.number.isRequired,
  pages: PropTypes.number.isRequired,
  handleNextClick: PropTypes.func.isRequired
};

var PagesIndicator = function PagesIndicator(e) {
  var t = e.css,
      a = e.page,
      n = e.pages,
      o = t || "small pt-2";
  return React__default.createElement("div", {
    className: o
  }, "Page ".concat(a, " / ").concat(n));
};

PagesIndicator.propTypes = {
  css: PropTypes.string,
  page: PropTypes.number.isRequired,
  pages: PropTypes.number.isRequired
};

var PreviousPageButton = function PreviousPageButton(e) {
  var t = e.css,
      a = e.page,
      n = e.handlePrevClick,
      o = "".concat(t || "btn btn-sm btn-link text-white pr-2").concat(1 === a ? " disabled" : ""),
      r = _slicedToArray(React.useState(!1), 2),
      s = r[0],
      i = r[1];

  return React__default.createElement("button", {
    className: o,
    onClick: function onClick() {
      i(!0), n(), setTimeout(function () {
        i(!1);
      }, 500);
    },
    disabled: s
  }, React__default.createElement("i", {
    className: "material-icons"
  }, "keyboard_arrow_left"));
};

PreviousPageButton.propTypes = {
  css: PropTypes.string,
  page: PropTypes.number.isRequired,
  handlePrevClick: PropTypes.func.isRequired
};

var ZoomIn = function ZoomIn(e) {
  var t = e.css,
      a = e.scale,
      n = e.maxScale,
      o = e.handleZoomIn,
      r = "".concat(t || "btn btn-sm btn-link text-white pl-2").concat(a === n ? " disabled" : "");
  return React__default.createElement("button", {
    type: "button",
    className: r,
    onClick: o
  }, React__default.createElement("i", {
    className: "material-icons"
  }, "zoom_in"));
};

ZoomIn.propTypes = {
  css: PropTypes.string,
  scale: PropTypes.number.isRequired,
  maxScale: PropTypes.number.isRequired,
  handleZoomIn: PropTypes.func.isRequired
};

var ZoomOut = function ZoomOut(e) {
  var t = e.css,
      a = e.scale,
      n = e.minScale,
      o = e.handleZoomOut,
      r = "".concat(t || "btn btn-sm btn-link text-white pr-2").concat(a === n ? " disabled" : "");
  return React__default.createElement("button", {
    type: "button",
    className: r,
    onClick: o
  }, React__default.createElement("i", {
    className: "material-icons"
  }, "zoom_out"));
};

ZoomOut.propTypes = {
  css: PropTypes.string,
  scale: PropTypes.number.isRequired,
  minScale: PropTypes.number.isRequired,
  handleZoomOut: PropTypes.func.isRequired
};

var ResetZoom = function ResetZoom(e) {
  var t = e.css,
      a = e.scale,
      n = e.defaultScale,
      o = e.handleResetZoom,
      r = "".concat(t || "btn btn-sm btn-link text-white px-2", "\n    ").concat(a === n ? " disabled" : "");
  return React__default.createElement("button", {
    type: "button",
    className: r,
    onClick: o
  }, React__default.createElement("i", {
    className: "material-icons"
  }, "refresh"));
};

ResetZoom.propTypes = {
  css: PropTypes.string,
  scale: PropTypes.number.isRequired,
  defaultScale: PropTypes.number.isRequired,
  handleResetZoom: PropTypes.func.isRequired
};

var RotateLeft = function RotateLeft(e) {
  var t = e.css,
      a = e.rotationAngle,
      n = e.handleRotateLeft,
      o = "\n    ".concat(t || "btn btn-sm btn-link text-white pr-2", "\n    ").concat(-90 === a ? " disabled" : "", "\n  ");
  return React__default.createElement("button", {
    type: "button",
    className: o,
    onClick: n
  }, React__default.createElement("i", {
    className: "material-icons"
  }, "rotate_left"));
};

RotateLeft.propTypes = {
  css: PropTypes.string,
  rotationAngle: PropTypes.number.isRequired,
  handleRotateLeft: PropTypes.func.isRequired
};

var ResetRotation = function ResetRotation(e) {
  var t = e.css,
      a = e.rotationAngle,
      n = e.handleResetRotation,
      o = "\n    ".concat(t || "btn btn-sm btn-link text-white px-2", "\n    ").concat(0 === a || 360 === a ? " disabled" : "", "\n  ");
  return React__default.createElement("button", {
    type: "button",
    className: o,
    onClick: n
  }, React__default.createElement("i", {
    className: "material-icons"
  }, "refresh"));
};

ResetRotation.propTypes = {
  css: PropTypes.string,
  rotationAngle: PropTypes.number.isRequired,
  handleResetRotation: PropTypes.func.isRequired
};

var RotateRight = function RotateRight(e) {
  var t = e.css,
      a = e.rotationAngle,
      n = e.handleRotateRight,
      o = "\n    ".concat(t || "btn btn-sm btn-link text-white pl-2", "\n    ").concat(90 === a ? " disabled" : "", "\n  ");
  return React__default.createElement("button", {
    type: "button",
    className: o,
    onClick: n
  }, React__default.createElement("i", {
    className: "material-icons"
  }, "rotate_right"));
};

RotateRight.propTypes = {
  css: PropTypes.string,
  rotationAngle: PropTypes.number.isRequired,
  handleRotateRight: PropTypes.func.isRequired
};

var Navigation = function Navigation(e) {
  var t = e.page,
      a = e.pages,
      n = e.scale,
      o = e.defaultScale,
      r = e.maxScale,
      s = e.minScale,
      i = e.rotationAngle,
      l = e.hideZoom,
      c = e.hideRotation,
      p = e.css,
      u = e.handlePrevClick,
      d = e.handleNextClick,
      h = e.handleZoomIn,
      m = e.handleResetZoom,
      f = e.handleZoomOut,
      R = e.handleRotateLeft,
      g = e.handleResetRotation,
      y = e.handleRotateRight;
  return React__default.createElement("div", {
    className: p.navbarWrapper ? p.navbarWrapper : "container rounded bg-dark text-white"
  }, React__default.createElement("div", {
    className: "row"
  }, React__default.createElement("div", {
    className: "col-sm-4"
  }, l ? void 0 : React__default.createElement("div", {
    className: "btn-group",
    role: "group"
  }, React__default.createElement(ZoomOut, {
    scale: n,
    minScale: s,
    css: p.zoomOutBtn,
    handleZoomOut: f
  }), React__default.createElement(ResetZoom, {
    scale: n,
    defaultScale: o,
    css: p.resetZoomBtn,
    handleResetZoom: m
  }), React__default.createElement(ZoomIn, {
    scale: n,
    maxScale: r,
    css: p.zoomInBtn,
    handleZoomIn: h
  }))), React__default.createElement("div", {
    className: "col-sm-4"
  }, React__default.createElement("div", {
    className: "btn-group",
    role: "group"
  }, React__default.createElement(PreviousPageButton, {
    css: p.previousPageBtn,
    page: t,
    pages: a,
    handlePrevClick: u
  }), React__default.createElement(PagesIndicator, {
    css: p.pageIndicator,
    page: t,
    pages: a
  }), React__default.createElement(NextPageButton, {
    css: p.nextPageBtn,
    page: t,
    pages: a,
    handleNextClick: d
  }))), React__default.createElement("div", {
    className: "col-sm-4"
  }, c ? void 0 : React__default.createElement("div", {
    className: "btn-group",
    role: "group"
  }, React__default.createElement(RotateLeft, {
    css: p.rotateLeftBtn,
    rotationAngle: i,
    handleRotateLeft: R
  }), React__default.createElement(ResetRotation, {
    css: p.resetRotationBtn,
    rotationAngle: i,
    handleResetRotation: g
  }), React__default.createElement(RotateRight, {
    css: p.rotateRightBtn,
    rotationAngle: i,
    handleRotateRight: y
  })))));
};

Navigation.propTypes = {
  page: PropTypes.number.isRequired,
  pages: PropTypes.number.isRequired,
  scale: PropTypes.number,
  defaultScale: PropTypes.number,
  maxScale: PropTypes.number,
  minScale: PropTypes.number,
  rotationAngle: PropTypes.number,
  hideZoom: PropTypes.bool,
  hideRotation: PropTypes.bool,
  css: PropTypes.shape({
    navbarWrapper: PropTypes.string,
    pages: PropTypes.string,
    pageIndicator: PropTypes.string,
    previousPageBtn: PropTypes.string,
    nextPageBtn: PropTypes.string,
    zoomOutBtn: PropTypes.string,
    resetZoomBtn: PropTypes.string,
    zoomInBtn: PropTypes.string,
    rotateLeftBtn: PropTypes.string,
    resetRotationBtn: PropTypes.string,
    rotateRightBtn: PropTypes.string
  }),
  elements: PropTypes.shape({
    previousPageBtn: PropTypes.any,
    nextPageBtn: PropTypes.any,
    pages: PropTypes.any
  }),
  handlePrevClick: PropTypes.func.isRequired,
  handleNextClick: PropTypes.func.isRequired,
  handleZoomIn: PropTypes.func.isRequired,
  handleResetZoom: PropTypes.func.isRequired,
  handleZoomOut: PropTypes.func.isRequired,
  handleRotateLeft: PropTypes.func.isRequired,
  handleResetRotation: PropTypes.func.isRequired,
  handleRotateRight: PropTypes.func.isRequired
}, Navigation.defaultProps = {
  css: {},
  elements: {}
};

var Loader = function () {
  function e() {
    return _classCallCheck(this, e), _possibleConstructorReturn(this, _getPrototypeOf(e).apply(this, arguments));
  }

  return _inherits(e, React.Component), _createClass(e, [{
    key: "render",
    value: function value() {
      return React__default.createElement("div", {
        className: "d-flex justify-content-center vertical-align-middle text-dark"
      }, React__default.createElement("p", {
        className: "h4 loader-text"
      }, "Loading"), React__default.createElement("div", {
        className: "p-2"
      }, React__default.createElement("div", {
        className: "spinner-grow",
        style: {
          width: "0.5rem",
          height: "0.5rem",
          animationDuration: "1.5s",
          animationDelay: "0s"
        }
      })), React__default.createElement("div", {
        className: "p-2"
      }, React__default.createElement("div", {
        className: "spinner-grow",
        style: {
          width: "0.5rem",
          height: "0.5rem",
          animationDuration: "1.5s",
          animationDelay: "0.5s"
        }
      })), React__default.createElement("div", {
        className: "p-2"
      }, React__default.createElement("div", {
        className: "spinner-grow",
        style: {
          width: "0.5rem",
          height: "0.5rem",
          animationDuration: "1.5s",
          animationDelay: "2s"
        }
      })));
    }
  }]), e;
}(),
    PDFViewer = function () {
  function a(e) {
    var t;
    return _classCallCheck(this, a), (t = _possibleConstructorReturn(this, _getPrototypeOf(a).call(this, e))).state = {
      page: t.props.page,
      pages: 0,
      scale: t.props.scale,
      defaultScale: t.props.scale,
      rotationAngle: t.props.rotationAngle,
      isReady: !1
    }, t.getPageCount = t.getPageCount.bind(_assertThisInitialized(t)), t.handlePrevClick = t.handlePrevClick.bind(_assertThisInitialized(t)), t.handleNextClick = t.handleNextClick.bind(_assertThisInitialized(t)), t.handleZoomIn = t.handleZoomIn.bind(_assertThisInitialized(t)), t.handleResetZoom = t.handleResetZoom.bind(_assertThisInitialized(t)), t.handleZoomOut = t.handleZoomOut.bind(_assertThisInitialized(t)), t.handleRotateLeft = t.handleRotateLeft.bind(_assertThisInitialized(t)), t.handleResetRotation = t.handleResetRotation.bind(_assertThisInitialized(t)), t.handleRotateRight = t.handleRotateRight.bind(_assertThisInitialized(t)), t;
  }

  return _inherits(a, React__default.Component), _createClass(a, [{
    key: "getPageCount",
    value: function value(e) {
      var t = this;
      this.state.pages !== e && setTimeout(function () {
        t.setState({
          pages: e,
          isReady: !0
        });
      }, 5e3);
    }
  }, {
    key: "handlePrevClick",
    value: function value() {
      1 !== this.state.page && (this.setState({
        page: this.state.page - 1
      }), this.props.onPrevBtnClick && this.props.onPrevBtnClick(this.state.page - 1));
    }
  }, {
    key: "handleNextClick",
    value: function value() {
      this.state.page !== this.pages && (this.setState({
        page: this.state.page + 1
      }), this.props.onNextBtnClick && this.props.onNextBtnClick(this.state.page + 1));
    }
  }, {
    key: "handleZoomIn",
    value: function value() {
      this.state.scale < this.props.maxScale && this.setState({
        scale: this.state.scale + this.props.scaleStep
      }), this.props.onZoom && this.props.onZoom(this.state.scale + this.props.scaleStep);
    }
  }, {
    key: "handleResetZoom",
    value: function value() {
      this.setState({
        scale: this.state.defaultScale
      }), this.props.onZoom && this.props.onZoom(this.state.defaultScale);
    }
  }, {
    key: "handleZoomOut",
    value: function value() {
      this.state.scale > this.props.minScale && this.setState({
        scale: this.state.scale - this.props.scaleStep
      }), this.props.onZoom && this.props.onZoom(this.state.scale - this.props.scaleStep);
    }
  }, {
    key: "handleRotateLeft",
    value: function value() {
      -90 !== this.state.rotationAngle && this.setState({
        rotationAngle: -90
      }), this.props.onRotation && this.props.onRotation(-90);
    }
  }, {
    key: "handleResetRotation",
    value: function value() {
      0 !== this.state.rotationAngle && this.setState({
        rotationAngle: 0
      }), this.props.onRotation && this.props.onRotation(0);
    }
  }, {
    key: "handleRotateRight",
    value: function value() {
      90 !== this.state.rotationAngle && this.setState({
        rotationAngle: 90
      }), this.props.onRotation && this.props.onRotation(90);
    }
  }, {
    key: "render",
    value: function value() {
      for (var e, t = this, a = 0, n = Object.entries(this.props.document); a < n.length; a++) {
        var o = _slicedToArray(n[a], 2),
            r = o[0],
            s = o[1];

        e = "base64" === r ? {
          data: atob(s)
        } : s;
      }

      var i = this.props,
          l = i.loader,
          c = i.maxScale,
          p = i.minScale,
          u = i.hideNavbar,
          d = i.hideZoom,
          h = i.hideRotation,
          m = i.navbarOnTop,
          f = i.navigation,
          R = i.css,
          g = i.canvasCss,
          y = i.onDocumentClick,
          _ = this.state,
          P = _.page,
          b = _.pages,
          T = _.scale,
          v = _.defaultScale,
          k = _.rotationAngle,
          x = f,
          C = React__default.createElement(RenderPdf, {
        src: e,
        page: P,
        scale: T,
        rotation: k,
        pageCount: function pageCount(e) {
          return t.getPageCount(e);
        }
      }),
          E = null;
      return !u && 0 < b && (E = !f || f && "object" === _typeof(f) ? React__default.createElement(Navigation, {
        page: P,
        pages: b,
        scale: T,
        defaultScale: v,
        maxScale: c,
        minScale: p,
        rotationAngle: k,
        hideZoom: d,
        hideRotation: h,
        css: f ? f.css : void 0,
        handleNextClick: this.handleNextClick,
        handlePrevClick: this.handlePrevClick,
        handleZoomIn: this.handleZoomIn,
        handleResetZoom: this.handleResetZoom,
        handleZoomOut: this.handleZoomOut,
        handleRotateLeft: this.handleRotateLeft,
        handleResetRotation: this.handleResetRotation,
        handleRotateRight: this.handleRotateRight
      }) : React__default.createElement(x, {
        page: P,
        pages: b,
        scale: T,
        defaultScale: v,
        maxScale: c,
        minScale: p,
        rotationAngle: k,
        hideZoom: d,
        hideRotation: h,
        handleNextClick: this.handleNextClick,
        handlePrevClick: this.handlePrevClick,
        handleZoomIn: this.handleZoomIn,
        handleResetZoom: this.handleResetZoom,
        handleZoomOut: this.handleZoomOut,
        handleRotateLeft: this.handleRotateLeft,
        handleResetRotation: this.handleResetRotation,
        handleRotateRight: this.handleRotateRight
      })), React__default.createElement("div", {
        className: R || "container text-center"
      }, React__default.createElement("div", {
        style: {
          display: this.state.isReady ? "none" : "block"
        }
      }, React__default.createElement("div", {
        className: g || "",
        style: g ? {} : {
          height: "1000px",
          maxHeight: "1000px",
          maxWidth: "1000px",
          overflow: "auto"
        }
      }, l || React__default.createElement(Loader, null))), React__default.createElement("div", {
        style: {
          display: this.state.isReady ? "block" : "none"
        }
      }, m ? React__default.createElement("div", null, React__default.createElement("div", null, E), React__default.createElement("div", {
        className: g || "",
        style: g ? {} : {
          height: "1000px",
          maxHeight: "1000px",
          maxWidth: "1000px",
          overflow: "auto"
        },
        onClick: y
      }, C)) : React__default.createElement("div", null, React__default.createElement("div", {
        className: g || "",
        style: g ? {} : {
          height: "1000px",
          maxHeight: "1000px",
          maxWidth: "1000px",
          overflow: "auto"
        },
        onClick: y
      }, C), React__default.createElement("div", null, E))));
    }
  }]), a;
}();

PDFViewer.propTypes = {
  document: PropTypes.shape({
    url: PropTypes.string,
    base64: PropTypes.string
  }).isRequired,
  loader: PropTypes.node,
  page: PropTypes.number,
  scale: PropTypes.number,
  scaleStep: PropTypes.number,
  maxScale: PropTypes.number,
  minScale: PropTypes.number,
  css: PropTypes.string,
  canvasCss: PropTypes.string,
  rotationAngle: PropTypes.number,
  onDocumentClick: PropTypes.func,
  onPrevBtnClick: PropTypes.func,
  onNextBtnClick: PropTypes.func,
  onZoom: PropTypes.func,
  onRotation: PropTypes.func,
  hideNavbar: PropTypes.bool,
  navbarOnTop: PropTypes.bool,
  hideZoom: PropTypes.bool,
  hideRotation: PropTypes.bool,
  navigation: PropTypes.oneOfType([PropTypes.shape({
    css: PropTypes.shape({
      navbarWrapper: PropTypes.string,
      zoomOutBtn: PropTypes.string,
      resetZoomBtn: PropTypes.string,
      zoomInBtn: PropTypes.string,
      previousPageBtn: PropTypes.string,
      pageIndicator: PropTypes.string,
      nextPageBtn: PropTypes.string,
      rotateLeftBtn: PropTypes.string,
      resetRotationBtn: PropTypes.string,
      rotateRightBtn: PropTypes.string
    })
  }), PropTypes.any])
}, PDFViewer.defaultProps = {
  page: 1,
  defaultScale: 1,
  scale: 1,
  scaleStep: 1,
  maxScale: 3,
  minScale: 1,
  rotationAngle: 0,
  hideNavbar: !1,
  hideZoom: !1,
  hideRotation: !1,
  navbarOnTop: !1
}, module.exports = PDFViewer;